import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import fonts from '@editor/fonts.json';

export default Vue.component('font-selector', {
  template: require('./template.html'),
  name: 'font-selector',
  computed: {
    ...mapGetters(['viewport', 'activeDroplet', 'currentSite', 'activeDropletItem']),
    allColumns() {
      let list = [];
      const droplet = this.activeDroplet;
      if (droplet.rows) {
        _.forEach(this.activeDroplet.rows,
          row => _.forEach(row.columns, column => list.push(column)));
      }
      if (droplet.cards) {
        list = list.concat(droplet.cards);
      }
      if (droplet.columns) {
        list = list.concat(droplet.columns);
      }
      return { list };
    },
    fonts() {
      const list = fonts.webSafe.concat(this.currentSite.fonts).sort();
      const f = new RegExp(this.searchFonts, 'gi');
      return _.filter(list, font => font.match(f));
    },
  },
  props: ['option', 'active-state', 'dom-nodes', 'component-config'],
  data() {
    return {
      showFonts: false,
      searchFonts: '',
      display: {
        fontFamily: fonts.defaultFont,
      },
      selectedFont: fonts.defaultFont,
      debTime: 250,
      innerDomNodes: {},
    };
  },
  watch: {
    viewport() {
      this.setInitialValue();
    },
    activeState() {
      this.setInitialValue();
    },
    activeDropletItem: {
      handler() {
        this.setInitialValue();
      },
      deep: true,
    },
  },
  created() {
    // check for previous values
    this.setInitialValue();
  },
  methods: {
    setInitialValue() {
      const option = this.option;
      const $vm = {
        viewport: this.viewport,
        droplet: this.activeDroplet,
      };
      let selector;
      let property;
      const useRoot = option.$el === 'root';
      const $root = this.domNodes.$dropletRow;
      const $el = useRoot ? $root : $root.querySelectorAll(option.$el)[0];
      if (option.payload.updates) {
        const rule = option.payload.updates[0];
        property = rule.property;
        if (this.activeDropletItem._id && this.componentConfig.itemList) {
          const inner = this.componentConfig.itemList.selectors[property];
          const nested = inner || '';
          selector = `#drp-${this.activeDropletItem._id}${nested}${this.activeState}`;
        } else {
          selector = rule.selector.replace(/\$\{state\}/gi, this.activeState);
          selector = selector.replace(/\$\{dropletId\}/gi, this.activeDroplet._id);
        }
      } else {
        property = option.payload.properties[0];
        selector = option.payload.selector;
        if (option.payload.activeState) {
          selector = this._buildStateSelector({
            selector: option.payload.selector,
            activeState: this.activeState,
          });
        }
      }
      this.display.fontFamily = this._getFontFamily(
        $vm,
        selector,
        property,
        $el,
      );
    },
    onChange(font) {
      const option = this.option;
      const payload = {};
      payload.drp = this.activeDroplet;
      payload.val = font;
      payload.viewport = this.viewport;
      if (option.payload.updates) {
        _.forEach(option.payload.updates, (item) => {
          let selector;
          if (this.activeDropletItem._id && this.componentConfig.itemList) {
            // this is in the event a user is targeting a specific item within a droplet
            // eg, a nav link or a column in columns
            const inner = this.componentConfig.itemList.selectors[item.property];
            const nested = inner || '';
            selector = `#drp-${this.activeDropletItem._id}${nested}${this.activeState}`;
          } else {
            this.resetCustomQueries(item);
            selector = item.selector.replace(/\$\{state\}/gi, this.activeState);
            selector = selector.replace(/\$\{dropletId\}/gi, this.activeDroplet._id);
          }
          payload.property = item.property;
          payload.selector = selector;
          payload.noId = item.noId;
          this.$emit('check-legacy-styles', payload);
          this.$store.dispatch('changeDropletCss', payload);
        });
      } else {
        // draw active state in selector if needed
        if (option.payload.activeState) {
          payload.selector = this._buildStateSelector({
            selector: option.payload.selector,
            activeState: this.activeState,
          });
        } else {
          payload.selector = option.payload.selector;
        }
        _.forEach(option.payload.properties, (property) => {
          payload.property = property;
          this.$emit('check-legacy-styles', payload);
          this.$store.dispatch('changeDropletCss', payload);
        });
      }
      this.$emit('css-generator', this.cssPayload(), this.option.plugin);
      this.$emit('update-changes', true);
      this.display.fontFamily = font;
    },
    resetCustomQueries(update) {
      if (!this.componentConfig.itemList) {
        return;
      }
      const inner = this.componentConfig.itemList.selectors[update.property];
      const nested = inner || '';
      const customRule = new RegExp(`#drp-[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}${nested}`, 'gi');
      _.forEach(this.activeDroplet.mediaQueries, (rule) => {
        if (rule.selector.match(customRule)) {
          const property = _.find(rule.properties, r => r.property === update.property);
          if (property) {
            this.$store.dispatch('setDropletVal', {
              drp: property,
              key: this.viewport,
              val: 'default',
            });
          }
        }
      });
    },
    cssPayload() {
      let payload = false;
      if (this.option.payload.useColumns) {
        payload = {
          key: 'drps',
          value: [...this.allColumns.list, this.activeDroplet],
        };
      }
      return payload;
    },
    formatFontName(name) {
      const n = name.replace(/-|_/gi, ' ');
      return _.startCase(n);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/style-sidebar/options/font-selector/index.js